<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updateGroup">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Update Group</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="formData['name']"
                                          :rules="[vRules.required]" autofocus density="compact" label="Name"/>
                        </v-col>
                        <v-col class="py-0" cols="12" sm="6">
                            <v-select v-model="formData['status']" :items="['enabled','disabled']"
                                      :rules="[vRules.required]" density="compact" label="Status">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="formData['description']"
                                        :rules="[vRules.required]" density="compact" label="Description"/>
                        </v-col>

                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    group: {
        type: Object
    }
});

const formData = reactive({
    valid: false,
    name: props.group.name ?? null,
    status: props.group.status ?? null,
    description: props.group.description ?? null,
});
const emits = defineEmits(['update:modelValue', 'updateGroup']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const updateGroup = () => {
    errors.value = [];
    send('put', `asset-groups/${props.group.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateGroup', response.data.data.asset_group);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
